import { TableCell } from './Table';
import React, { memo } from 'react';
import PropTypes from 'prop-types';

export type TableColumnProps = {
  item: any;
  accessor: (row: any) => JSX.Element | '' | undefined;
  width: number | string | undefined;
};

const TableColumn: React.FC<TableColumnProps> = memo(
  ({ accessor, item, width }) => {
    let value: any = undefined;
    try {
      value = accessor(item);
    } catch (e) {
      console.error('Error accessing column value', item, e);
    }
    return (
      <TableCell
        title={typeof value === 'string' ? value : undefined}
        role="cell"
        style={{ width }}
      >
        {value}
      </TableCell>
    );
  }
);

TableColumn.propTypes = {
  accessor: PropTypes.any.isRequired,
  item: PropTypes.any.isRequired,
  width: PropTypes.any,
};

export default TableColumn;
